import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'taxi-plate',
  templateUrl: './taxi-plate.component.html',
  styleUrls: ['./taxi-plate.component.css']
})

export class TaxiPlateComponent implements OnInit {
  @Input() text1!: number; //? مدل ورودی کامپوننت
  @Input() text2!: string; //? مدل ورودی کامپوننت
  @Input() text3!: number; //? مدل ورودی کامپوننت
  @Input() text4!: number; //? مدل ورودی کامپوننت

  constructor() { }
  ngOnInit(): void {

  }

}
